import ButtonGetSicherungsdateienComponent from '../../component/buttons/ButtonGetSicherungsdateienComponent';
import CalendarComponent from '../../component/CalendarComponent/CalendarComponent';

export default function LandingPageAussendienst() {

    return (
        <>
            <div className="container">

                <h3>Aussendienst</h3>

                <ButtonGetSicherungsdateienComponent />
               
                <br />

                <CalendarComponent />
            </div>

        </>
    );
}
